<script setup lang="ts">
import { MarkTypes } from '@storyblok/richtext';
import { type StoryblokRichTextNode, type StoryblokRichTextProps } from '@storyblok/vue';
import { h, type VNode } from 'vue';

// eslint-disable-next-line regex/invalid
import { NuxtLink } from '#components';

export type StoryblokRichTextOverrideProps = Pick<StoryblokRichTextProps, 'doc'>;

// PROPS
defineProps<StoryblokRichTextOverrideProps>();

// METHODS
const convertNodeAttrsToStoryblokMultilink = (attrs: any): StoryblokMultilink => ({
    fieldtype: 'multilink',
    id: attrs?.uuid,
    url: (attrs?.linktype === 'url' || attrs?.linktype === 'asset') && attrs?.href,
    cached_url: attrs?.href,
    target: attrs?.target,
    anchor: attrs?.anchor,
    linktype: attrs?.linktype,
    story: attrs?.story,
    email: attrs?.linktype === 'email' && attrs?.href,
});

// DATA
const resolvers = {
    [MarkTypes.LINK]: (node: StoryblokRichTextNode<VNode>): VNode => {
        return h(
            NuxtLink,
            {
                to: storyblokResolveLink(convertNodeAttrsToStoryblokMultilink(node.attrs)),
                target: node.attrs?.target,
                ...node?.attrs?.custom,
            },
            () => node.text
        );
    },
};
</script>

<template>
    <div class="prose prose-slate w-full">
        <StoryblokRichText :doc="doc" :resolvers="resolvers" />
    </div>
</template>
